import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation(["privacyPolicy"]);
  const numberOfPoints = 10;
  return (
    <main className="terms-and-conditions-container py-3 px-5">
      {Array.from(Array(numberOfPoints)).map((_, index) => (
        <div key={index} className="privacy-item-content">
          <h6>{t(`privacyPolicy.items.item${index + 1}`)}</h6>
          <div
            dangerouslySetInnerHTML={{
              __html: t(`privacyPolicy.items.content${index + 1}`),
            }}
          ></div>
        </div>
      ))}
    </main>
  );
};

export default PrivacyPolicy;
